import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { BadgeEntityAttribute } from '@/components/docs-main/reference-pages/badge/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    attribute: null
  },
  setup(__props: any) {

const props = __props as {
  attribute: string;
};



const badgeNamesMap: Record<BadgeEntityAttribute | string, string> = {
  optional: 'Optional',
  readonly: 'Read-only',
  beta: 'Beta',
  deprecated: 'Deprecated',
  hidden: 'Hidden',
  static: 'Static',
  warning: 'Warning',
};

const badgeClasses = computed(() => {
  if (badgeNamesMap[props.attribute]) return [`entity-badge_${props.attribute}`];
  return [`entity-badge_default`];
});

return { __sfc: true,props, badgeNamesMap, badgeClasses }
}

})